import KakiMakanSubSectionList from "@components/Blocks/SubSectionNav/KakiMakanSubSectionList";
import { RESTAURANT_SEARCH_PLACEHOLDER_COPY } from "@config/kakiMakan";
import RestaurantSearch from "@elements/RestaurantSearch/RestaurantSearch";
import { ProcessedArticleData } from "@hooks/transformer/useOSResponse";
import useKakiMakanSearchAndFilter from "@hooks/useKakiMakanSearchAndFilter";

type KakiMakanSearchFilterProps = {
  onDataFetched: (data: ProcessedArticleData[]) => void;
  onLoading: (isLoading: boolean) => void;
  onReset: () => void;
  onQueryChange?: (search: string, filter: string | null) => void;
};

/**
 * KakiMakanSearchFilter
 * Description: [Combines search and filter functionalities for Kaki Makan]
 * @param props - The props required by the component (if any)
 * @returns The rendered React element
 */
export function KakiMakanSearchFilter({
  onDataFetched,
  onLoading,
  onReset,
  onQueryChange,
}: KakiMakanSearchFilterProps) {
  const { handleQueryChange } = useKakiMakanSearchAndFilter({
    onDataFetched,
    onLoading,
    onReset,
    onQueryChange,
  });

  return (
    <>
      <RestaurantSearch
        onSearch={(query: string) => {
          void handleQueryChange({ search: query });
        }}
        placeholder={RESTAURANT_SEARCH_PLACEHOLDER_COPY}
      />
      <KakiMakanSubSectionList
        onSelect={(filter: string | null) => {
          void handleQueryChange({ filter });
        }}
      />
    </>
  );
}
